import styled from 'styled-components';

export const Button = styled.div`
  width: 100%;
  cursor: pointer;
  :hover {
    color: #ffffff;
    text-decoration: none;
  }
`;
